import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import googleLogo from '../../assets/google-logo.svg';
import { googleLoginUrl } from '../../lib/cognito';

const GoogleButton = withStyles(theme => ({
  root: {
    width: '100%',
    padding: '0.5rem',
    fontSize: '1.2rem',
    textTransform: 'none',
    color: '#757575',
    backgroundColor: '#ffffff',
    border: `1px solid ${theme.palette.primary.main}`,
    boxShadow: 'none',
    marginBottom: '1.5rem',
    '&:hover': {
      backgroundColor: '#ffffff',
    },
  },
}))(Button);

const GoogleLoginButton = ({children, state={} }) => {
  const url = googleLoginUrl(state);
  return (
    <GoogleButton variant="contained" color="primary"
      href={url}
      startIcon={<img width="18" height="18" src={googleLogo} alt="Google Logo"/>}
    >
      {children}
    </GoogleButton>
  );
};

GoogleLoginButton.propTypes = {
  children: PropTypes.node.isRequired,
  state: PropTypes.object,
};

export default GoogleLoginButton;
